import { PhoneIcon } from "@heroicons/react/24/outline";
import {
  MaskedFormInput,
  type MaskedFormInputProps,
} from "@/core/components/masked-form-input";
import { useEnv } from "@/core/env";
import { phoneNumberMask } from "@/core/masks/phone-masks";

export type PhoneInputProps = Omit<
  MaskedFormInputProps,
  "maskOptions" | "name"
> & { name?: string };

export const PhoneInput = ({
  value,
  onChange,
  label = "Phone Number",
  placeholder = "Phone Number",
  name = "phone_number",
  info,
  ...props
}: PhoneInputProps) => {
  const { appEnv } = useEnv();

  const testWarning =
    appEnv !== "production"
      ? "You're in a test environment. Use a test number like (xxx) 555-0100 to (xxx) 555-0199."
      : undefined;

  return (
    <MaskedFormInput
      type="tel"
      role="textbox"
      inputMode="numeric"
      value={value}
      onChange={onChange}
      label={label}
      placeholder={placeholder}
      startAdornment={value ? "+1" : undefined}
      endAdornment={<PhoneIcon className="h-6 w-6" />}
      maskOptions={phoneNumberMask}
      name={name}
      info={info || testWarning}
      {...props}
    />
  );
};
